import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage/LandingPage';
import DemoPage from './components/DemoPage/DemoPage';
import FeaturesPage from './components/FeaturesPage/FeaturesPage';
import PricingPage from './components/PricingPage/PricingPage';
import AboutUs from './components/AboutUs/AboutUs';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './components/TermsOfService/TermsOfService';
import ContactUs from './components/ContactUs/ContactUs';
import FAQ from './components/FAQ/FAQ';
import HelpCenter from './components/HelpCenter/HelpCenter';
import RegistrationPage from './components/RegistrationPage/RegistrationPage';
import LoginPage from './components/LoginPage/LoginPage';
import TestLoader from './components/TestLoader/TestLoader';
import TestScreen from './components/TestScreen/TestScreen';
import StudentDashboard from './components/StudentDashboard/StudentDashboard';
import SubjectsDashboard from './components/SubjectsDashboard/SubjectsDashboard';
import ReportAnalyzer from './components/ReportAnalyzer/ReportAnalyzer';
import TestReport from './components/TestReport/TestReport';
import AIDoctorReport from './components/AIDoctorReport/AIDoctorReport';
import Profile from './components/Profile/Profile';
import PaymentStatus from './components/PricingPage/PaymentStatus';
import NotificationsPage from './components/NotificationsPage/NotificationsPage';
import SubscriptionPage from './components/SubscriptionPage/SubscriptionPage';
import ProtectedRoute from './components/Shared/ProtectedRoute';
import AdminProtectedRoute from './components/Shared/AdminProtectedRoute';
import AdminLogin from './components/Admin/AdminLogin';
import AdminDashboard from './components/Admin/AdminDashboard';
import AdminUsers from './components/Admin/AdminUsers';
import AdminPurchases from './components/Admin/AdminPurchases';
import AdminTests from './components/Admin/AdminTests';
import PushNotificationManager from './components/Admin/PushNotificationManager';
import ModelPaperGenerator from './components/ModelPaperGenerator/ModelPaperGenerator';
import ModelPaperView from './components/ModelPaperView/ModelPaperView';
import ExamBoosterGenerator from './components/ExamBooster/ExamBoosterGenerator';
import ExamBoosterEngine from './components/ExamBooster/ExamBoosterEngine';
import { useTranslation } from 'react-i18next';
import './App.css';

function App() {
  const { i18n } = useTranslation();

  React.useEffect(() => {
    document.documentElement.dir = i18n.dir();
    document.documentElement.lang = i18n.language;
  }, [i18n.language, i18n]);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/help" element={<HelpCenter />} />
          <Route path="/register" element={<RegistrationPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Protected Routes */}
          <Route path="/loader" element={<ProtectedRoute><TestLoader /></ProtectedRoute>} />
          <Route path="/test" element={<ProtectedRoute><TestScreen /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><StudentDashboard /></ProtectedRoute>} />
          <Route path="/subjects" element={<ProtectedRoute><SubjectsDashboard /></ProtectedRoute>} />
          <Route path="/analysis" element={<ProtectedRoute><ReportAnalyzer /></ProtectedRoute>} />
          <Route path="/report" element={<ProtectedRoute><TestReport /></ProtectedRoute>} />
          <Route path="/ai-doctor-report" element={<ProtectedRoute><AIDoctorReport /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/payment-status" element={<ProtectedRoute><PaymentStatus /></ProtectedRoute>} />
          <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
          <Route path="/subscriptions" element={<ProtectedRoute><SubscriptionPage /></ProtectedRoute>} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminProtectedRoute><AdminDashboard /></AdminProtectedRoute>} />
          <Route path="/admin/users" element={<AdminProtectedRoute><AdminUsers /></AdminProtectedRoute>} />
          <Route path="/admin/purchases" element={<AdminProtectedRoute><AdminPurchases /></AdminProtectedRoute>} />
          <Route path="/admin/tests" element={<AdminProtectedRoute><AdminTests /></AdminProtectedRoute>} />
          <Route path="/admin/notifications" element={<AdminProtectedRoute><PushNotificationManager /></AdminProtectedRoute>} />
          <Route path="/generate-paper" element={<ProtectedRoute><ModelPaperGenerator /></ProtectedRoute>} />
          <Route path="/view-paper" element={<ProtectedRoute><ModelPaperView /></ProtectedRoute>} />
          <Route path="/exam-booster" element={<ProtectedRoute><ExamBoosterGenerator /></ProtectedRoute>} />
          <Route path="/exam-booster/engine" element={<ProtectedRoute><ExamBoosterEngine /></ProtectedRoute>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
